<template>
    <div>

        <mensajeSistema></mensajeSistema>

        <v-row>
            <v-col class="d-flex justify-end">
                <TableButtonComp normalButton @click="verCalendario" v-if="componenteEvento.visualizar_submodulo"
                    textButton="Ver calendario" iconBut="fas fa-calendar" />
            </v-col>
        </v-row>

        <v-row>
            <v-col cols="12">

                <ComundataTablecomp :itemkey="''" :headers="ActividadesAlumnosHeadersheaders"
                    :items="actividadesAlumnoFilter" :search="search" whitSearch
                    noResultsText="Sin actividades programadas">
                    <template v-slot>
                        <v-row>
                            <v-col cols="12" md="6" sm="6">
                                <AutocompleteComp textLabel="Área" v-model="filtroProgAlum.id_area" :items="areaAlumno"
                                    item-value="id_area_mant" item-text="desc_area" @change="eventAreaAlum" />
                            </v-col>
                            <v-col cols="12" md="6" sm="6">
                                <AutocompleteComp textLabel="Curso" v-model="filtroProgAlum.id_curso"
                                    :items="cursoAlumFilter" :isDisable="inhabilitarCursoAlum" item-value="id_curso"
                                    item-text="desc_curso" @change="eventCursoAlum">
                                </AutocompleteComp>
                            </v-col>
                        </v-row>

                    </template>

                    <template v-slot:calificacion_revision="{ item }">
                        {{ item.calificacion_revision ? item.calificacion_revision : 'Sin calificación' }}
                    </template>

                    <template v-slot:action_curso="{ item }">
                        <v-chip color="white">
                            <v-avatar left :color="item.color_curso">
                                <v-icon small color="white">{{ item.icono_curso }}</v-icon>
                            </v-avatar>
                            <span class="font-weight-black">{{ item.desc_curso }}</span>
                        </v-chip>
                    </template>

                    <template v-slot:action_fecha_actividad="{ item }">
                        {{ item.fecha_actividad | filtroFecha }}
                        <br />
                        {{ item.hora_fin_actividad | filtroFormatoHora }}
                    </template>



                    <template v-slot:action_desc_estado_alumno="{ item }">
                        <v-chip small dark class="font-weight-black" :color="item.color_estado_alumno">
                            {{ item.actividad_vencidad == true && item.archivo_alumno == null ? 'No realizado' :
                                item.desc_estado_alumno != '' ?
                                    item.desc_estado_alumno : 'Pendiente por realizar' }}
                        </v-chip>
                    </template>

                    <template v-slot:action_ver="{ item }">
                        <TableButtonComp verButton tooltipText="Ver actividad"
                            v-if="componenteEvento.visualizar_submodulo" @click="verDetalleActividad(item)" />

                    </template>


                    <template v-slot:action_descargar="{ item }">
                        <TableButtonComp downloadButton tooltipText="Descargar actividad asignada"
                            v-if="componenteEvento.visualizar_submodulo"
                            @click="download(URL_SPACE + '/' + item.ruta_actividad)" />

                    </template>


                    <template v-slot:action_cargar="{ item }">
                        <TableButtonComp uploadButton tooltipText="Cargar archivo de actividad"
                            v-if="componenteEvento.visualizar_submodulo"
                            :disabled="(item.actividad_vencidad == true) || (item.id_estado_actividad == 3)"
                            @click="cargarActividad(item)" />

                    </template>
                </ComundataTablecomp>
            </v-col>


        </v-row>

        <ComunDialogComp v-model="modal_verActividad" maxWidth="500" @close-modal="modal_verActividad = false">
            <template v-slot:title>
                Actividad : {{ verItem.desc_tipo_actividad }}
            </template>
            <template v-slot:body>
                <v-row class="d-flex justify-center">
                    <v-col cols="12" class="d-flex justify-center">
                        <v-chip small label class="mx-2">
                            <span class="font-weight-black">Unidad: </span>
                            {{ verItem.nombre_tema }}
                        </v-chip>
                        -
                        <v-chip small label class="mx-2">
                            <span class="font-weight-black">Tema: </span>
                            {{ verItem.nombre_clase }}
                        </v-chip>

                    </v-col>
                    <v-col cols="12" class="pt-2">
                        <v-card>
                            <v-card-text>
                                <p class="black--text">
                                    <span class="font-weight-black">Fecha de entrega:</span>
                                    {{ verItem.fecha_actividad }}
                                </p>
                                <p class="black--text">
                                    <span class="font-weight-black">Hora de entrega:</span>
                                    {{ verItem.hora_fin_actividad | filtroFormatoHora }}
                                </p>
                                <p class="black--text">
                                    <span class="font-weight-black">Objetivo de la actividad:</span>
                                    {{ verItem.observacion_actividad }}
                                </p>
                                <p class="black--text">
                                    <span class="font-weight-black">Observación al estudiante:</span>
                                    {{ verItem.observacion_docente }}
                                </p>
                                <p class="black--text">
                                    <span class="font-weight-black">Calificación: </span>
                                    <span v-if="verItem.calificacion_revision">{{
                                        verItem.calificacion_revision
                                    }}</span>
                                    <span v-else> PENDIENTE</span>
                                </p>

                                <p class="black--text">
                                    <span class="font-weight-black">Observación de la calificación:</span>
                                    {{ verItem.observacion_revision }}
                                </p>
                            </v-card-text>
                        </v-card>

                    </v-col>
                </v-row>


            </template>
        </ComunDialogComp>
        <v-form ref="formDatos" lazy-validation>
            <ComunDialogComp v-model="modal_cargarActividad" maxWidth="750"
                @close-modal="modal_cargarActividad = false">
                <template v-slot:title>
                    Cargar actividad: {{ actividadItem.desc_tipo_actividad }}
                </template>
                <template v-slot:body>
                    <v-row>
                        <v-col cols="12" class="d-flex justify-center pb-0 pt-0 mt-8">
                            <p class="body-1 mb-0 black--text">
                                <span class="font-weight-black">Unidad: </span> {{ actividadItem.nombre_tema }} -
                                <span class="font-weight-black">Tema: </span> {{ actividadItem.nombre_clase }}
                            </p>
                        </v-col>
                        <br>
                        <v-col cols="12" md="7" class="py-0">
                            <v-file-input v-model="archivoSubir" accept=".docx,.pdf,.doc"
                                label="Cargar archivo de actividad" :rules="[rul.required]"></v-file-input>
                        </v-col>


                        <v-col cols="12" class="py-0">
                            <v-textarea v-model="cargarItem.observacion_alumno" label="Observación"
                                rows="2"></v-textarea>
                        </v-col>

                        <v-col cols="12" class="py-0" v-if="actividadItem.ruta_alumno">
                            Descargar archivo de actividad enviada
                            <v-tooltip bottom color="#1b1b1b">
                                <template v-slot:activator="{ on }">
                                    <v-btn v-on="on" class="mx-2 btn_otro"
                                        @click="download(URL_SPACE + '/' + actividadItem.ruta_actividad)" fab x-small>
                                        <v-icon>fa-file-download</v-icon>
                                    </v-btn>
                                </template>
                                <span>DESCARGAR ARCHIVO DE ACTIVIDAD ENVIADA</span>
                            </v-tooltip>
                        </v-col>
                    </v-row>

                </template>
                <template v-slot:actions>
                    <v-spacer />
                    <TableButtonComp normalButton @click="saveItem" textButton="Guardar" iconBut="fas fa-save" />
                    <TableButtonComp normalButton classButton="ml-2" @click="modal_cargarActividad = false"
                        textButton="Cancelar" classColor="red" />
                </template>
            </ComunDialogComp>

        </v-form>
        <component :is="compCalendario" :modalCalendario="estadoModalCalendario" @close="estadoModalCalendario = false"
            :parametros="parametroCalendario">
        </component>

    </div>
</template>


<script>
import axios, { API_URL } from "@/helpers/axios"
import { mapMutations, mapGetters, mapActions } from 'vuex';
import CalendarioActividadesAlumno from './components/CalendarioActividades.vue'
import SeleccionCompetenciaDesempeño from '../../seleccionCompetenciaDesempeño.vue';
import { BUCKET_ORIGIN_SPACE } from '../../../helpers/axios';
import { ActividadesAlumnosHeadersheaders } from '../../../helpers/headersTable'
import AutocompleteComp from '../../../components/ComponentsEst/AutocompleteComp.vue';
import TableButtonComp from '../../../components/ComponentsEst/TableButtonComp.vue';
import ComundataTablecomp from '../../../components/ComponentsEst/ComundataTablecomp.vue';
import ComunDialogComp from '../../../components/ComponentsEst/ComunDialogComp.vue';

export default {
    name: "actividadesAlumno",

    components: {
        CalendarioActividadesAlumno,
        SeleccionCompetenciaDesempeño,
        AutocompleteComp,
        TableButtonComp,
        ComundataTablecomp,
        ComunDialogComp
    },

    data: () => ({
        paramComponente: { 'id_submodulo': 75, "id_modulo": 7 },
        test: false,
        datoLogin: sessionStorage,
        ruta_api: API_URL,
        ActividadesAlumnosHeadersheaders,
        rul: {
            required: value => !!value || 'Campo Requerido',
            inputReq: value => !!value || 'Campo Requerido',
            selectReq: value => !!value || 'Debe seleccionar un campo de la lista',
            email: value => /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.([a-zA-Z]{2,4})+$/.test(value) || 'El correo electrónico es incorrecto',
            min4: v => (v || '').length >= 4 || 'Mínimo 4 caracteres',
            min6: v => (v || '').length >= 6 || 'Mínimo 6 caracteres',
            min8: v => (v || '').length >= 8 || 'Mínimo 8 caracteres',
            max10: v => (v || '').length <= 10 || 'Máximo 10 caracteres',
            max11: v => (v || '').length <= 11 || 'Máximo 11 caracteres',
            max12: v => (v || '').length <= 12 || 'Máximo 12 caracteres',
            max20: v => (v || '').length <= 20 || 'Máximo 20 caracteres',
            max30: v => (v || '').length <= 30 || 'Máximo 30 caracteres',
            max40: v => (v || '').length <= 40 || 'Máximo 40 caracteres',
            max50: v => (v || '').length <= 50 || 'Máximo 50 caracteres',
            max60: v => (v || '').length <= 60 || 'Máximo 60 caracteres',
            max100: v => (v || '').length <= 100 || 'Máximo 100 caracteres',
            max150: v => (v || '').length <= 150 || 'Máximo 150 caracteres',

            email_null: value => {
                if (value == '') {
                    return false
                }
                else {
                    const pattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.([a-zA-Z]{2,4})+$/
                    return pattern.test(value) || 'El correo electrónico es incorrecto'
                }
            },
        },
        // consulta principal
        inhabilitarCursoAlum: true,

        filtroProgAlum: [],
        areaAlumno: [],
        cursoAlumno: [],
        cursoAlumFilter: [],
        actividadesAlumno: [],
        actividadesAlumnoFilter: [],
        search: "",
        modal_verActividad: false,
        verItem: [],
        modal_cargarActividad: false,
        actividadItem: [],
        cargarItem: [],
        archivoSubir: null,
        compCalendario: null,
        parametroCalendario: {},
        estadoModalCalendario: true,
        URL_SPACE: BUCKET_ORIGIN_SPACE,
    }),

    computed: {
        ...mapGetters('login', ['componenteEvento']),
    },
    mounted() {
        this.loadMain()
    },
    created() {
        this.actualizarParamentro()
    },
    methods: {
        ...mapMutations('mensajeSis', ['setEnviarMens']),
        ...mapActions('login', ['parametroComponente']),

        actualizarParamentro() {
            this.parametroComponente(this.paramComponente)
        },
        async loadMain() {
            try {
                let params = `periodo/${this.datoLogin.id_ano_lectivo}/colegio/${this.datoLogin.id_colegio}/alumno/${this.datoLogin.id}`
                let response = await axios.get(`academico/actividades/alumnoActividad/${params}`)

                let data = response.data
                this.areaAlumno = data.AlumnoArea
                this.cursoAlumno = data.AlumnoCurso
                this.actividadesAlumno = data.ActividadesAlumno
                this.actividadesAlumnoFilter = data.ActividadesAlumno
            }

            catch (error) {
                this.setEnviarMens({ tipo: "E", mensaje: `Error: ${error}`, tiempo: null })
            }
        },
        async searchData() {

            let filtrarData = this.actividadesAlumno

            if (this.filtroProgAlum.id_curso != "" && this.filtroProgAlum.id_curso != undefined) {
                filtrarData = await filtrarData.filter(el => el.id_curso == this.filtroProgAlum.id_curso)
            }

            if (this.filtroProgAlum.id_area != "" && this.filtroProgAlum.id_area != undefined) {
                filtrarData = await filtrarData.filter(el => el.id_area == this.filtroProgAlum.id_area)
            }

            if (this.search != "" && this.search != undefined) {
                filtrarData = await filtrarData.filter(el => el.nombre_tema == this.search)
            }

            this.actividadesAlumnoFilter = filtrarData
        },

        eventAreaAlum() {
            this.inhabilitarCursoAlum = false
            this.cursoAlumFilter = this.cursoAlumno.filter(el => el.id_area == this.filtroProgAlum.id_area)
            this.actividadesAlumnoFilter = this.actividadesAlumno
        },

        eventCursoAlum() {
            this.actividadesAlumnoFilter = this.actividadesAlumno.filter(el => el.id_curso == this.filtroProgAlum.id_curso)

        },

        async verDetalleActividad(item) {
            this.modal_verActividad = true;
            this.verItem = await Object.assign({}, item);
        },

        async cargarActividad(item) {
            this.modal_cargarActividad = true;
            this.actividadItem = await Object.assign({}, item);
        },

        limpiarForm() {
            this.cargarItem = { observacion_alumno: "" };
            this.archivoSubir = null;
            this.$refs.formDatos.resetValidation();
        },

        async saveItem() {
            if (this.$refs.formDatos.validate()) {
                try {
                    let formData = new FormData();
                    formData.append("subirArchivo", this.archivoSubir);
                    formData.append("usuario", this.datoLogin.id);
                    formData.append("docente", this.actividadItem.id_docente);
                    formData.append("colegio", this.datoLogin.id_colegio);
                    formData.append("periodo", this.datoLogin.id_ano_lectivo);

                    formData.append("nivel", this.actividadItem.id_nivel);
                    formData.append("grado", this.actividadItem.id_grado);
                    formData.append("seccion", this.actividadItem.id_seccion);

                    formData.append("actividad", this.actividadItem.id_actividad);
                    formData.append(
                        "observacion_alumno",
                        this.cargarItem.observacion_alumno
                    );

                    let res = await axios.post(
                        "/academico/progDocente/addActividadAlumno/",
                        formData,
                        {
                            headers: {
                                "Content-Type": "multipart/form-data",
                            },
                        }
                    );

                    this.setEnviarMens({
                        tipo: res.data.messageT,
                        mensaje: res.data.message,
                        tiempo: null,
                    });

                    this.limpiarForm();
                    this.modal_cargarActividad = false;
                    this.loadMain();
                } catch (error) {
                    this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
                }
            }
        },

        // componente de  calendario
        verCalendario() {
            this.parametroCalendario = {};
            this.compCalendario = "CalendarioActividadesAlumno";
            this.estadoModalCalendario = true;
        },

        // Función que descarga del SPACE
        async download(url) {
            //console.log(url)
            await this.$Files['downloadFetch']({ url });
        }
    },
};
</script>
